import {
  SELL_PANEL_ACTIVE,
  PAY_PANEL_LOADING,
  IS_COMPLETE_PANEL_ACTIVE,
  SALE_ORDER_DATA,
  CUS_OBJ,
  TAX_TABLE_DATA,
  DEFAULT_DEC_PLACES,
  SALE_PAYMENTS,
  PROD_TAB_DATA,
  CUS_ACC_DETAIL,
  ORDER_STATUSES,
  PAY_TYPES,
  IS_MAIN_LOADING,
  DATA_PRINT,
  PROMO_TABLE_DATA,
  PAY_PROCESS_START,
  IS_NOTE_VISIBLE,
  CURR_ORDER_STATUS,
  IS_CREDIT_ENABLED,
  IS_SELL_LOYALTY_ENABLED,
  LOYALTYAMOUNTVALUE,
  IS_DETAIL_LOADING,
  PREVENT_RUNNER_EXEC,
  IS_REFUNDABLE,
  IS_PARKED_VISIBLE,
  QUICK_KEYS_DETAILS,
  IS_FOLDER_OPEN,
  QUICK_KEY_COUNT,
  MAIN_QUICK_KEY_DETAILS,
  ACTIVE_FOLDER_DATA,
  ACTIVE_COLOR_CODE,
  IS_PROD_LOADING,
  DISCOUNT_PRICE_TOTAL,
  SALES_STATUS_NAME,
  DISCOUNT_ROW_VISIBLE,
  PROMO_CODE_POPOVER_VISIBLE,
  IS_TAX_POPOVER_VISIBLE,
  IS_PROMO_POPOVER_VISIBLE,
  IS_DISCOUNT_POPOVER_VISIBLE,
  IS_PAY_POPOVER_VISIBLE,
  IS_TAX_EXCLUSIVE,
  DEFAULT_SALES_TAX_ID,
  IS_BASIC_PERCENT,
  FORM_DIS_CURR,
  FORM_DIS_PER,
  FORM_SELL_NOTE,
  FORM_AMOUNT_TO_PAY,
  FORM_LAYOUT_NAME,
  DEFAULT_LOYALTY_AMOUNT,
  REFUND_NEG_HANDLE,
  IS_EXCHANGE_SALE,
  REFUND_PROD_KEYS,
  IS_ROW_DATA_UPDATED,
  PROMO_CODE_NOTIFY,
  COMPLETE_SALE,
  EARNED_LOYALTY,
  SHOW_ISSUE_CREDIT_MODAL,
  ACC_LAYBY_CREDITAMOUNT,
  SALE_REMAINING_AMOUNT,
  DELETED_PROD,
  PROMO_PROMPT,
  SHOW_PROMO_PROMPT,
  LOAD_IS_IN_PROGRESS,
  TOTAL_SAVING,
  ISALLPAID,
  SINGLE_SCREEN_FOR_CART,
  LOAD_SINGLE_PAY,
  SEND_PRINT,
  CART_MAIN_CLASS,
  ALL_QUICK_KEY_DETAILS,
  ENABLE_TAX_CODE
} from '../../constants/ActionTypes'
import {
  clearAllSale,
  getDecryptID,
  getSalesOrderID,
  isEmptyObject,
  notAllowMsgCheck,
  parseFloatCustom
} from './GlobalMethods'
import ds from '../../Services/DataServices'
import { BEHAVIOUR_TYPE } from '../../Services/DataServices'
import {
  GetIndexDBDataByTableName,
  saveEntitiesDatatoIndexBD
} from './IndexDBActions'
import {
  CURRENT_VERSION,
  INDEX_DB_NAME,
  INDEX_DB_TABLES
} from '../../constants/IndexDBData'
import moment from 'moment'
import { message } from 'antd'
import { TabSaleString } from '../../components/TabletPrintString'

export function loadIsSalePanelActive (loadValue) {
  return dispatch => {
    dispatch({ type: SELL_PANEL_ACTIVE, payload: loadValue })
  }
}

export function loadIsPaymentPanelLoading (loadValue) {
  return dispatch => {
    dispatch({ type: PAY_PANEL_LOADING, payload: loadValue })
  }
}

export function loadIsPaymentPanelActionCompleteActive (loadValue, callFrom) {
  return dispatch => {
    dispatch({ type: IS_COMPLETE_PANEL_ACTIVE, payload: loadValue })
  }
}

export function loadSaleOrderJson (loadValue) {
  return dispatch => {
    dispatch({ type: SALE_ORDER_DATA, payload: loadValue })
  }
}

export function loadCustomerObj (loadValue) {
  return dispatch => {
    dispatch({ type: CUS_OBJ, payload: loadValue })
  }
}

export function loadTableDataSellTax (loadValue) {
  return dispatch => {
    dispatch({ type: TAX_TABLE_DATA, payload: loadValue })
  }
}

export function loadDefaultDecimalPlace (loadValue) {
  return dispatch => {
    dispatch({ type: DEFAULT_DEC_PLACES, payload: loadValue })
  }
}

export function loadSalePayments (loadValue) {
  return dispatch => {
    dispatch({ type: SALE_PAYMENTS, payload: loadValue })
  }
}

export function loadTableDataSaleProduct (loadValue) {
  return dispatch => {
    dispatch({ type: PROD_TAB_DATA, payload: loadValue })
  }
}

export function loadCustomerAccountDetails (loadValue) {
  return dispatch => {
    dispatch({ type: CUS_ACC_DETAIL, payload: loadValue })
  }
}

export function loadSalesOrderStatuses (loadValue) {
  return dispatch => {
    dispatch({ type: ORDER_STATUSES, payload: loadValue })
  }
}

export function loadStorePaymentTypes (loadValue) {
  return dispatch => {
    dispatch({ type: PAY_TYPES, payload: loadValue })
  }
}

export function loadIsMainLoading (loadValue) {
  return dispatch => {
    dispatch({ type: IS_MAIN_LOADING, payload: loadValue })
  }
}

export function loadDataToPrint (loadValue) {
  return dispatch => {
    dispatch({ type: DATA_PRINT, payload: loadValue })
  }
}

export function loadTableDataSellPromotion (loadValue) {
  return dispatch => {
    dispatch({ type: PROMO_TABLE_DATA, payload: loadValue })
  }
}

export function loadIsSalePaymentProcessStart (loadValue) {
  return dispatch => {
    dispatch({ type: PAY_PROCESS_START, payload: loadValue })
  }
}

export function loadIsNotesRowVisible (loadValue) {
  return dispatch => {
    dispatch({ type: IS_NOTE_VISIBLE, payload: loadValue })
  }
}

export function loadCurrentSalesOrderStatusID (loadValue) {
  return dispatch => {
    dispatch({ type: CURR_ORDER_STATUS, payload: loadValue })
  }
}

export function loadIsStoreCreditEnabled (loadValue) {
  return dispatch => {
    dispatch({ type: IS_CREDIT_ENABLED, payload: loadValue })
  }
}

export function loadIsLoyaltyEnabled (loadValue) {
  return dispatch => {
    dispatch({ type: IS_SELL_LOYALTY_ENABLED, payload: loadValue })
  }
}
export function loadLoyaltyAmountValue (loadValue) {
  return dispatch => {
    dispatch({ type: LOYALTYAMOUNTVALUE, payload: loadValue })
  }
}

export function loadIsDetailLoading (loadValue) {
  return dispatch => {
    dispatch({ type: IS_DETAIL_LOADING, payload: loadValue })
  }
}

export function loadPreventSellRunnerExecution (loadValue) {
  return dispatch => {
    dispatch({ type: PREVENT_RUNNER_EXEC, payload: loadValue })
  }
}

export function loadIsRefundSale (loadValue) {
  return dispatch => {
    dispatch({ type: IS_REFUNDABLE, payload: loadValue })
  }
}

export function loadParkedSaleModalvisible (loadValue) {
  return dispatch => {
    dispatch({ type: IS_PARKED_VISIBLE, payload: loadValue })
  }
}

export function loadQuicKeyDetails (loadValue) {
  return dispatch => {
    dispatch({ type: QUICK_KEYS_DETAILS, payload: loadValue })
  }
}

export function loadIsFolderActive (loadValue) {
  return dispatch => {
    dispatch({ type: IS_FOLDER_OPEN, payload: loadValue })
  }
}

export function loadQuickKeyCount (loadValue) {
  return dispatch => {
    dispatch({ type: QUICK_KEY_COUNT, payload: loadValue })
  }
}

export function loadMainQuicKeyDetails (loadValue) {
  return dispatch => {
    dispatch({ type: MAIN_QUICK_KEY_DETAILS, payload: loadValue })
  }
}
export function loadAllQuicKeyDetails (loadValue) {
  return dispatch => {
    dispatch({ type: ALL_QUICK_KEY_DETAILS, payload: loadValue })
  }
}

export function loadActiveFolderData (loadValue) {
  return dispatch => {
    dispatch({ type: ACTIVE_FOLDER_DATA, payload: loadValue })
  }
}

export function loadActiveColorCode (loadValue) {
  return dispatch => {
    dispatch({ type: ACTIVE_COLOR_CODE, payload: loadValue })
  }
}

export function loadIsProductLoading (loadValue) {
  return dispatch => {
    dispatch({ type: IS_PROD_LOADING, payload: loadValue })
  }
}

export function loadDiscountPriceTotal (loadValue) {
  return dispatch => {
    dispatch({ type: DISCOUNT_PRICE_TOTAL, payload: loadValue })
  }
}

export function loadCurrentSalesOrderStatusName (loadValue) {
  return dispatch => {
    dispatch({ type: SALES_STATUS_NAME, payload: loadValue })
  }
}

export function loadIsDiscountRowVisible (loadValue) {
  return dispatch => {
    dispatch({ type: DISCOUNT_ROW_VISIBLE, payload: loadValue })
  }
}

export function loadIsPromoCodePopoverVisible (loadValue) {
  return dispatch => {
    dispatch({ type: PROMO_CODE_POPOVER_VISIBLE, payload: loadValue })
  }
}

export function loadIsTaxPopoverVisible (loadValue) {
  return dispatch => {
    dispatch({ type: IS_TAX_POPOVER_VISIBLE, payload: loadValue })
  }
}

export function loadIsPromotionPopoverVisible (loadValue) {
  return dispatch => {
    dispatch({ type: IS_PROMO_POPOVER_VISIBLE, payload: loadValue })
  }
}

export function loadIsDiscountPopoverVisible (loadValue) {
  return dispatch => {
    dispatch({ type: IS_DISCOUNT_POPOVER_VISIBLE, payload: loadValue })
  }
}

export function loadIsPaymentPopoverVisible (loadValue) {
  return dispatch => {
    dispatch({ type: IS_PAY_POPOVER_VISIBLE, payload: loadValue })
  }
}

export function loadIsTaxExclusive (loadValue) {
  return dispatch => {
    dispatch({ type: IS_TAX_EXCLUSIVE, payload: loadValue })
  }
}
export function loadDefaultSalesTaxID (loadValue) {
  return dispatch => {
    dispatch({ type: DEFAULT_SALES_TAX_ID, payload: loadValue })
  }
}

export function loadBasicIsPercent (loadValue) {
  return dispatch => {
    dispatch({ type: IS_BASIC_PERCENT, payload: loadValue })
  }
}

export function loadFormDiscPer (loadValue) {
  return dispatch => {
    dispatch({ type: FORM_DIS_PER, payload: loadValue })
  }
}

export function loadFormDiscCurr (loadValue) {
  return dispatch => {
    dispatch({ type: FORM_DIS_CURR, payload: loadValue })
  }
}

export function loadFormSellNote (loadValue) {
  return dispatch => {
    dispatch({ type: FORM_SELL_NOTE, payload: loadValue })
  }
}

export function loadFormAmountToPay (loadValue) {
  return dispatch => {
    dispatch({ type: FORM_AMOUNT_TO_PAY, payload: loadValue })
  }
}

export function loadFormLayoutName (loadValue) {
  return dispatch => {
    dispatch({ type: FORM_LAYOUT_NAME, payload: loadValue })
  }
}

export function loadDefaultLoyaltyAmount (loadValue) {
  return dispatch => {
    dispatch({ type: DEFAULT_LOYALTY_AMOUNT, payload: loadValue })
  }
}

export function loadRefundNeg (loadValue) {
  return dispatch => {
    dispatch({ type: REFUND_NEG_HANDLE, payload: loadValue })
  }
}

export function loadExchangeSale (loadValue) {
  return dispatch => {
    dispatch({ type: IS_EXCHANGE_SALE, payload: loadValue })
  }
}

export function loadRefundProdKeys (loadValue) {
  return dispatch => {
    dispatch({ type: REFUND_PROD_KEYS, payload: loadValue })
  }
}

export function loadRowDataUpdated (loadValue) {
  return dispatch => {
    dispatch({ type: IS_ROW_DATA_UPDATED, payload: loadValue })
  }
}

export function laodPromoCodeNotify (loadValue) {
  return dispatch => {
    dispatch({ type: PROMO_CODE_NOTIFY, payload: loadValue })
  }
}

export function loadIsSaleCompleted (loadValue) {
  return dispatch => {
    dispatch({ type: COMPLETE_SALE, payload: loadValue })
  }
}

export function loadEarnedLoyalty (loadValue) {
  return dispatch => {
    dispatch({ type: EARNED_LOYALTY, payload: loadValue })
  }
}

export function loadShowIssueCreditModal (loadValue) {
  return dispatch => {
    dispatch({ type: SHOW_ISSUE_CREDIT_MODAL, payload: loadValue })
  }
}

export function loadAccLaybyCreditAmount (loadValue) {
  return dispatch => {
    dispatch({ type: ACC_LAYBY_CREDITAMOUNT, payload: loadValue })
  }
}

export function loadSaleRemainingAmount (loadValue) {
  return dispatch => {
    dispatch({ type: SALE_REMAINING_AMOUNT, payload: loadValue })
  }
}

export function loadDeletedProds (loadValue) {
  return dispatch => {
    dispatch({ type: DELETED_PROD, payload: loadValue })
  }
}

export function loadPromoPrompt (loadValue) {
  return dispatch => {
    dispatch({ type: PROMO_PROMPT, payload: loadValue })
  }
}

export function loadShowPrompPrompt (loadValue) {
  return dispatch => {
    dispatch({ type: SHOW_PROMO_PROMPT, payload: loadValue })
  }
}

export function loadIsInProgress (loadValue) {
  return dispatch => {
    dispatch({ type: LOAD_IS_IN_PROGRESS, payload: loadValue })
  }
}

export function loadTotalSaving (loadValue) {
  return dispatch => {
    dispatch({ type: TOTAL_SAVING, payload: loadValue })
  }
}

export function loadIsAllPaid (loadValue) {
  return dispatch => {
    dispatch({ type: ISALLPAID, payload: loadValue })
  }
}

export function loadSingleScreenForCart (loadValue) {
  return dispatch => {
    dispatch({ type: SINGLE_SCREEN_FOR_CART, payload: loadValue })
  }
}

export function loadSingleScreenPay (loadValue) {
  return dispatch => {
    dispatch({ type: LOAD_SINGLE_PAY, payload: loadValue })
  }
}

export function loadSendPrint (loadValue) {
  return dispatch => {
    dispatch({ type: SEND_PRINT, payload: loadValue })
  }
}

export function loadCartClass (loadValue) {
  return dispatch => {
    dispatch({ type: CART_MAIN_CLASS, payload: loadValue })
  }
}

export function loadEnableTaxCode (loadValue) {
  return dispatch => {
    dispatch({ type: ENABLE_TAX_CODE, payload: loadValue })
  }
}
/////////////////////////////////////

export function processCompleteSale (
  sellActionLog,
  getCurrentSalesOrderStatusID,
  getAccLaybyCreditAmount,
  getSelectedOutlet,
  getSavings,
  getSaleOrderJson,
  isOnline,
  allowPrint,
  form,
  dispatch
) {
  const promoCodeID = getPromoCodeID()
  dispatch(loadIsPaymentPanelLoading(true))
  let actionLogs = []
  if (sellActionLog && sellActionLog.length > 0) {
    actionLogs = sellActionLog
    actionLogs.map(a => {
      a.SalesOrderID = getSalesOrderID()
    })
  }
  let body = {
    BehaviorName: 3,
    SalesOrderID: getSalesOrderID(),
    SalesOrderStatusID: getCurrentSalesOrderStatusID,
    CreditAmount:
      getAccLaybyCreditAmount && getAccLaybyCreditAmount.length > 0
        ? getAccLaybyCreditAmount[0]
        : 0,
    PromoCodeID: promoCodeID && promoCodeID.length > 0 ? promoCodeID : [],
    OutletID: getSelectedOutlet ? getSelectedOutlet : '',
    TotalSavings: getSavings ? parseFloatCustom(getSavings) : 0,
    Balance: getSaleOrderJson.Balance ? getSaleOrderJson.Balance : 0,
    Change: getSaleOrderJson.Change
      ? parseFloatCustom(getSaleOrderJson.Change)
      : 0,
    ActionLog: actionLogs
  }
  postSalesOrderStatus(
    body,
    isOnline,
    getSaleOrderJson,
    allowPrint,
    dispatch,
    form
  )
}

function getPromoCodeID (getSaleOrderJson) {
  const codeIDs = []
  const sale = getSaleOrderJson
  if (sale && !isEmptyObject(sale)) {
    if (sale.Products && sale.Products.length > 0) {
      sale.Products.map(ew => {
        if (ew.Promotions && ew.Promotions.length > 0) {
          const promo = ew.Promotions[0]
          if (promo.PromoCodes && promo.PromoCodes.length > 0) {
            promo.PromoCodes.map(xx => {
              codeIDs.push(xx.CodeID)
            })
          }
        }
      })
    }
  }

  return codeIDs
}

async function postSalesOrderStatus (
  body,
  isOnline,
  getSaleOrderJson,
  allowPrint,
  dispatch,
  form
) {
  if (isOnline && body.SalesOrderID) {
    const postMainSaleStatusData = ds.postMainSaleStatus(
      body,
      BEHAVIOUR_TYPE.UPDATE
    )
    await postMainSaleStatusData
      .then(res => {
        saleComplete(false, allowPrint, dispatch, form)
        offlineSaleComplete(
          getSaleOrderJson.indexKey,
          body,
          false,
          allowPrint,
          dispatch,
          form
        )
        //console.log('TC recessionstatuspayrec ==> ', res)
        // if (res && res.length > 0) {
        //   // setIsMainLoading(false);
        //   dispatch(loadIsMainLoading(false));
        // }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        saleComplete(true, allowPrint, dispatch, form)
      })
  } else {
    offlineSaleComplete(
      getSaleOrderJson.indexKey,
      body,
      true,
      allowPrint,
      dispatch,
      form
    )
  }
}

const offlineSaleComplete = async (
  indexKey,
  body,
  isOffline,
  allowPrint,
  dispatch,
  form
) => {
  if (indexKey) {
    const data = GetIndexDBDataByTableName(INDEX_DB_NAME, INDEX_DB_TABLES.SALES)
    data
      .then(async e => {
        const saleExist = e.filter(er => er.indexKey == indexKey)
        if (saleExist && saleExist.length > 0) {
          let sale = { ...saleExist[0] }
          let postBody = { ...body }
          postBody.datetime = moment().format()
          postBody.indexKey = indexKey
          sale.completeBody = isOffline ? postBody : {}
          sale.isCompleted = true
          sale.inProgress = false
          sale.isParked = false
          sale.isOffline = isOffline
          sale.datetime = moment().format() // this should be here because on complete button the sale is done & pay button could be clicked more than once, like park sale scenario
          if (sale.createBody && !isEmptyObject(sale.createBody)) {
            sale.createBody.datetime = moment().format()
            // if (
            //   sale.createBody.Products &&
            //   sale.createBody.Products.length > 0
            // ) {
            //   sale.createBody.Products.map((q, i) => {
            //     const incremented = i + 1
            //     q.indexKey = `${indexKey}_${incremented}`
            //     if (q.TaxComponents && q.TaxComponents.length > 0) {
            //       q.TaxComponents.map((rr, ii) => {
            //         const incremented_tax = ii + 1
            //         rr.indexKey = `${indexKey}_${incremented_tax}`
            //       })
            //     }
            //   })
            // }
            // if (
            //   sale.createBody.totalTaxComponent &&
            //   sale.createBody.totalTaxComponent.length > 0
            // ) {
            //   sale.createBody.totalTaxComponent.map((wex, io) => {
            //     const incremented_total_tax = io + 1
            //     wex.indexKey = `${indexKey}_${incremented_total_tax}`
            //   })
            // }
          }
          if (sale.payBodys && sale.payBodys.length > 0) {
            sale.payBodys.map((a, i) => {
              const incremented_pay = i + 1
              a.indexKey_Pay = `${indexKey}_${incremented_pay}`
            })
          }
          await saveEntitiesDatatoIndexBD(
            [sale],
            INDEX_DB_NAME,
            CURRENT_VERSION,
            INDEX_DB_TABLES.SALES,
            'offlineSaleComplete'
          )

          if (isOffline) saleComplete(false, allowPrint, dispatch, form)
          // saleComplete()
        }
      })
      .catch(e => {
        console.log('INDEX_DB_ERROR -> offlineSaleComplete -->', e)
      })
  }
}

function saleComplete (isCatch, allowPrint, dispatch, form) {
  // if (allowPrint) {
  //   if (checkIsWeb().exist) {
  //     printReceiptTemplate(true)
  //   } else {
  //     const fa = localStorage.getItem('printConfig')
  //     if (fa && fa != '0') {
  //       onPrintConfig()
  //     }
  //   }
  // }
  if (allowPrint) {
    dispatch(loadSendPrint(true))
  }
  // send command for open drawer
  dispatch(loadIsPaymentPanelLoading(false))
  dispatch(loadIsMainLoading(false))
  message.success(isCatch ? 'Sale Completed' : 'Sale Completed Successfull')
  dispatch(loadIsSaleCompleted(true))
  setTimeout(() => {
    clearAllSale(form, dispatch, false)
  }, 2000)
}

export function onPrintConfigNew (
  getReduxTemplatedData,
  getDataToPrint,
  outletName,
  registerName,
  allowPrintNote,
  allowDiscountShow,
  getCurrData
) {
  const expires_in = 18
  const gen_default = localStorage.getItem('printConfig')
    ? JSON.parse(localStorage.getItem('printConfig'))
    : false
  const tab_printers = localStorage.getItem('li_printrz')
    ? JSON.parse(localStorage.getItem('li_printrz'))
    : false
  const list_printers = []
  if (gen_default && !isEmptyObject(gen_default)) {
    list_printers.push(gen_default)
  }
  if (tab_printers && tab_printers.length > 0) {
    tab_printers.map(dss => {
      list_printers.push(dss)
    })
  }

  if (list_printers && list_printers.length > 0 && getDataToPrint) {
    list_printers.map(xxc => {
      if (xxc.isDefault || xxc.autoPrintAfterSale) {
        let tempData = false
        if (xxc.ip) {
          if (xxc.receiptID) {
            let fdata =
              getReduxTemplatedData &&
              getReduxTemplatedData.length > 0 &&
              getReduxTemplatedData.filter(
                e => xxc.receiptID == getDecryptID(e.templateID)
              ).length > 0
                ? getReduxTemplatedData.filter(
                    e => xxc.receiptID == getDecryptID(e.templateID)
                  )[0]
                : false

            if (fdata) tempData = fdata
          }
          if (!tempData) {
            tempData =
              getReduxTemplatedData &&
              getReduxTemplatedData.length > 0 &&
              getReduxTemplatedData.filter(e => e.isDefault == true).length > 0
                ? getReduxTemplatedData.filter(e => e.isDefault == true)[0]
                : {}
          }
        }
        let expires = new Date()
        expires.setTime(expires.getTime() + expires_in * 1000)
        let dataPrint = getDataToPrint
        dataPrint.outletName = outletName
        dataPrint.mainRegister = registerName

        const recieptHTML = TabSaleString(
          dataPrint,
          getCurrData ? getCurrData.currencyCode : '',
          2,
          tempData, // templateData,
          allowPrintNote,
          allowDiscountShow,
          xxc.ip,
          xxc.port,
          xxc.printCopies,
          xxc.openDrawer,
          xxc.deviceName,
          xxc.platform
        )
      }
    })
  }
}
